import { FieldFlowMap } from "@/hooks";
import type { NewAddressFormValues } from "@/types/form";

export type FieldName = keyof NewAddressFormValues;

export const FIELD_FLOW_MAP: FieldFlowMap<NewAddressFormValues> = {
    settlement: {
        name: "settlement",
        deps: [],
    },
    target: {
        name: "target",
        deps: ["settlement"],
    },
    house: {
        name: "house",
        deps: ["target"],
    },
    handleNumber: {
        name: "handleNumber",
        deps: ["target"],
    },
    handleComponents: {
        name: "handleComponents",
        deps: ["target"],
    },
    streetLabel: {
        name: "streetLabel",
        deps: ["settlement"],
    },
    address: {
        name: "address",
        deps: ["house", "handleNumber", "handleComponents"],
    },
};
